import React from "react";
import { Icons, Box } from "@curves/ui-base";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";

const WorkspaceBox = ({ openMembershipRecordDialog, openMembershipBillingRecordDialog }) => {
	return (
		<Box className="workspace-box">
			<SpeedDial ariaLabel="SpeedDial openIcon example" icon={<SpeedDialIcon openIcon={<Icons.Edit />} />}>
				<SpeedDialAction icon={<Icons.UserCircle />} tooltipTitle={'會籍紀錄'} onClick={openMembershipRecordDialog} />
				<SpeedDialAction icon={<Icons.Dollar htmlColor="#a45bc8" />} tooltipTitle={'收費明細'} onClick={openMembershipBillingRecordDialog} />
			</SpeedDial>
		</Box>
	);
};

export default WorkspaceBox;